import { ref } from 'vue';

import { getMultiCalls } from '@/api/apiService';
import { TypeCall } from '@/types/common';
import { SearchFilter } from '@/types/components';
import { IResponseCallManage } from '@/types/response';

export const useSelfServiceCallManage = () => {
  const nextOffset = ref(null); // 더 조회 했을 때 기준점
  const hasMore = ref(null); // 통역이 더 있는지 여부
  const listTagSelected = ref<TypeCall[]>([]); // 선택된 태그 목록
  const listCall = ref<IResponseCallManage[]>([]);
  const inputTextSearch = ref(''); // 검색 입력란
  const isFavorite = ref<boolean>(false);

  const listFilterSearch = ref<SearchFilter[]>([
    {
      label: 'label_all',
      value: 'ALL',
      isChecked: true,
    },
    {
      label: 'label_meeting',
      value: 'MEETING',
      isChecked: false,
    },
    {
      label: 'label_conference',
      value: 'CONFERENCE',
      isChecked: false,
    },
    {
      label: 'label_general',
      value: 'GENERAL',
      isChecked: false,
    },
  ]);

  const getSelectedTags = (): string[] => {
    const isAllChecked = listFilterSearch.value.some(({ value, isChecked }) => value === 'ALL' && isChecked);
    if (isAllChecked) {
      return [];
    }

    return listFilterSearch.value.reduce((acc: string[], { isChecked, value }) => {
      if (isChecked) {
        acc.push(value.toString());
      }
      return acc;
    }, []);
  };

  // 통화 목록 조회
  const getListCall = async (isGetMore = false) => {
    try {
      const { data, success } = await getMultiCalls(
        nextOffset.value,
        inputTextSearch.value,
        getSelectedTags(),
        isFavorite.value
      );

      if (!success) {
        throw new Error();
      }

      if (isGetMore) {
        listCall.value.push(...data.datas);
      } else {
        listCall.value = data.datas;
      }
    } catch {
      listCall.value = [];
    }
  };

  return {
    isFavorite,
    listCall,
    listTagSelected,
    listFilterSearch,
    inputTextSearch,
    getListCall,
    getSelectedTags,
  };
};
